// src/components/AboutComp.js
import React from 'react';
import './AboutComp.css';
import content from '../../config/content'; // Import the content

const AboutComp = () => {
    return (
        <div className="about">
            <div className="about-sec-text">
                <p>{content.aboutContent.introText}</p> {/* Use the introText from the config */}
                <br />
                <p>{content.aboutContent.closingText}</p> {/* Use the closingText from the config */}
            </div>
        </div>
    );
};

export default AboutComp;
